import '../Styles/ServicesShowcase.css';

const ServicesShowcase = () => {
  return (
    <section className="services-showcase-section">
      <div className="showcase-container">
        <img 
          src={require('../../Assets/hero.jpeg')} 
          alt="Professional in-home aesthetic treatment" 
          className="service-image"
        />
      </div>
    </section>
  );
};

export default ServicesShowcase;
